// extracted by mini-css-extract-plugin
export default {"container":"_3GJW1","header":"_2UeyD","main":"xl_Sk","error":"_1ZM-m"};